export default __webpack_public_path__ + "static/media/discord_white.284af673.svg";